import { initialState } from "./state"

export default {
  resetCampaign: state => {
    const init_state = initialState()
    Object.keys(state).forEach(key => {
      state[key] = init_state[key]
    })
  },
  setName: (state, payload) => (state.campaign.name = payload),
  setActive: (state, payload) => (state.campaign.active = payload),
  setStartDate: (state, payload) => (state.campaign.start_date = payload),
  setEndDate: (state, payload) => (state.campaign.end_date = payload),
  setUndefinedEndDate: (state, payload) =>
    (state.campaign.undefinedEndDate = payload),
  setEditingDatesValidation: (state, payload) =>
    (state.campaign.editingDatesValidation = payload)
}
